const theme = {
  font: {
    primary: `'Montserrat', serif`,
    secondary: `'Montserrat', serif`,
  },
  font_size: {
    small: "font-size: 16px; line-height: 24px",
    regular: "font-size: 18px; line-height: 28px",
    large: "font-size: 24px; line-height: 40px",
    larger: "font-size: 36px; line-height: 48px",
    xlarge: "font-size: 48px; line-height: 56px",
  },
  color: {
    white: {
      regular: "#FFFFFF",
      dark: "#F6F6F6",
    },
    black: {
      lighter: "#ABA8AF",
      light: "#564F62",
      regular: "#211E26",
    },
    primary: "#ffd94aff",
  },
  screen: {
    xs: "575px",
    sm: "767px",
    md: "991px",
    lg: "1199px",
  },
};

export default theme;
